export const PAYMENT_KINDS = {
  KIND_OTHER: 1,
  KIND_MONTHLY: 2,
  KIND_YEARLY_FEE: 3
};

export const PAYMENT_DIALOG_STYLE = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};
